<template>
<div class="chapter">
<div class="inner_page">
<div class="acknowledgments" id="acknowledgments">
<div class="chapterHead">
<h2 class="chapterTitleAC">Acknowledgments</h2>
</div>
<p class="para">There are many people who made this book possible. If anyone does not find his or her name here, please know that its absence was an oversight, and your contribution is deeply appreciated.</p>
<p class="para">First, we owe deep gratitude and appreciation to Eric Weider, who conceived of this book, put us together as a collaborative team, and provided generous support. Without Eric, <em class="italic">Once a Marine</em> would never have come to be.</p>
<p class="para">More of the same goes to our publisher, Savas Beatie LLC, and its managing director, Theodore P. “Ted” Savas. Ted shared our vision, flew to Los Angeles to meet with Nick and Eric, and accepted this book for publication with whole-hearted enthusiasm and respect for the integrity of the story.</p>
<p class="para">Word surgeon Dan Ferrara performed an exceptional line edit that made the book leaner, meaner, and harder hitting.</p>
<p class="para">From the beginning of our work, April Popaditch provided moral support and opened her heart so the family side of our story could be told more fully and frankly. April also keeps the Popaditch archives, to which we often referred for facts. Mike’s wife Sue Cross recognized before he did the great potential of Nick’s story and encouraged him to get on board. Both our families lost serious husband- and dad-time, but with no complaints.</p>
<p class="para">Jen Haskamp, Sgt. Haskamp in the book and now out of uniform but still a Marine through-and-through, was—and remains—our first, best reader. She provided crucial early encouragement and reassurance that the story does the Marine Corps proud.</p>
<p class="para">Marketing Director Sarah Keeney has been our indispensable logistics chief at Savas Beatie LLC. Lee Merideth produced the index and Ed Coleman drafted three maps; both did so on a very tight schedule. Eric Weider’s Executive Assistant Sari Kahn provided able assistance and backup. Transcriptionist Barb Krultz put hours and hours of digitally recorded blah-blah down on paper, making it look clearer than it sounded. We got smiles, along with incredibly fast turnaround of sundry printed versions of the manuscript, from Jennifer and Michael at FedEx Kinko’s on Napa Street in San Diego.</p>
<p class="para">Everyone who touched this book, at any stage of its progress, helped us, and we are mindful and thankful.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// OnceAMarine_acknowledgments.vue?37dbd334